import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  const {
    trackAddToCart
  } = useMetaPixel();
  return <main className="min-h-screen bg-white selection:bg-amber-light selection:text-charcoal" data-id="element-202">
      <HeroSection data-id="element-203" />
      <OpeningHook data-id="element-204" />
      <ProblemSection data-id="element-205" />
      <FailedSolutions data-id="element-206" />
      <MechanismSection data-id="element-207" />
      <WhatsInsideSection data-id="element-208" />
      <AudienceSection data-id="element-209" />
      <HowItWorks data-id="element-210" />
      <ProofSection data-id="element-211" />
      <FAQSection data-id="element-212" />
      <OfferSection onAddToCart={trackAddToCart} data-id="element-213" />
      <Footer data-id="element-214" />
    </main>;
}